import React from "react";
import { Layout } from "../../Layout";
import { SavedDescriptions } from "../../components/PostCompose/SavedDecriptions";

export function SavedDescriptionsPage() {
  return (
    <Layout>
      <div>
        <SavedDescriptions useModal={false} />
      </div>
    </Layout>
  );
}
